// Put all packages together.
// Used to generate umd/index.prod.js

import React from 'react';
import { createRoot } from 'react-dom/client';

import { IntlProvider } from 'react-intl';

import { initAdminParentAuth } from './lib/admin-parent-auth.js';
import { initChunkReloadHandler } from './lib/chunk-reload.js';
import { initWebVitals } from './lib/perf-metrics.js';
import TinodeWeb from './views/tinode-web.jsx';
import messages from './i18n.min/en.json';

// Recover from stale async-chunk references after a deploy (see chunk-reload.js).
// Installed first so it is listening before any lazy import() can fail.
initChunkReloadHandler();

// Start collecting Core Web Vitals as early as possible (see perf-metrics.js).
initWebVitals();

// Register admin-portal postMessage listener before bootstrap (see admin-parent-auth.js).
initAdminParentAuth();

document.getElementsByTagName('html')[0].setAttribute('lang', 'en');

const root = createRoot(document.getElementById('mountPoint'));
root.render(
  <IntlProvider locale="en" messages={messages} textComponent={React.Fragment}>
    <TinodeWeb />
  </IntlProvider>
);
